import React from 'react';

import Features from '@dashboard/enums/features';
import usePage from '@dashboard/hooks/usePage';

import CanUseFeature from '@dashboard/components/CanUseFeature';

import PageEditView from '../../components/PageEditView';
import { editorSection } from '../../pageEditTabs';

import CheckoutAbandonmentReminderEmailsForm from '../../scenes/PageSettings/components/CheckoutAbandonmentReminderEmailsForm';
import PaymentMethodsForm from '../../scenes/PageSettings/components/PaymentMethodsForm';

import CoverProcessingFeesForm from './components/CoverProcessingFeesForm';
import FeesForm from './components/FeesForm';
import PaymentOptionsForm from './components/PaymentOptionsForm';
import SettingsPageTax from './components/SettingsPageTax';

export const getCheckoutSections = ({ page }) => {
  const context = { page };
  const section = path => editorSection('checkout', path, context);

  return [
    {
      ...section('/manual-payments'),
      description: 'Choose how customers pay for one-time payments at checkout.',
      helpUrl:
        '/docs/articles/manual-payments-pay-in-full-by-invoice-pay-deposit-or-cash-on-delivery',
      component: (
        <CanUseFeature feature={Features.MANUAL_PAYMENTS}>
          <PaymentOptionsForm />
        </CanUseFeature>
      ),
    },
    {
      ...section('/payment-methods'),
      component: <PaymentMethodsForm />,
      description: 'Choose how customers can pay at checkout.',
      helpUrl: '/docs/articles/accept-multiple-payment-methods',
    },
    {
      ...section('/fees-surchages'),
      description: 'Add processing or other fees at checkout.',
      helpUrl: '/docs/articles/fees-and-surcharges',
      component: (
        <CanUseFeature feature={Features.CUSTOM_FEES}>
          <FeesForm />
        </CanUseFeature>
      ),
    },
    {
      ...section('/tax'),
      component: <SettingsPageTax />,
      description: 'Choose how tax is calculated.',
      helpUrl: '/docs/articles/how-to-charge-tax',
    },
    {
      ...section('/cover-processing-fees'),
      description: 'Let customers choose to cover processing fees at checkout.',
      helpUrl: '/docs/articles/cover-processing-fees',
      component: (
        <CanUseFeature feature={Features.CUSTOM_FEES}>
          <CoverProcessingFeesForm />
        </CanUseFeature>
      ),
    },
    {
      ...section('/abandonment'),
      title: 'Cart abandonment reminders',
      description: 'Automatically send up to 3 reminder emails when a checkout is abandoned.',
      helpUrl: '/help/articles/cart-abandonment',
      component: (
        <CanUseFeature feature={Features.CART_ABANDONMENT}>
          <CheckoutAbandonmentReminderEmailsForm />
        </CanUseFeature>
      ),
    },
  ].filter(tab => tab.isVisible(context));
};

const PageCheckout = () => {
  const { page } = usePage();

  return <PageEditView tabs={getCheckoutSections({ page })} />;
};

export default PageCheckout;
